import script from "./OpenAppView.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenAppView.vue?vue&type=script&setup=true&lang=js"

import "./OpenAppView.vue?vue&type=style&index=0&id=29bc8ca4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29bc8ca4"]])

export default __exports__